import {useState, useEffect} from 'react'
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'

import { withStyles } from '@material-ui/styles'
import styles from './agentsStyles'

import { httpRequest } from '../../../../ui-utils/api'
import { apiUrl } from '../../../../ui-utils/apiConfig'


const AgentsTable = ({ classes }) => {

  const [liveCalls, setLiveCalls] = useState([])

  const processCallRecords = (response) => {
    const currentTime = new Date()

    const departmentSeries = ['100000', '200000', '300000', '400000', '500000', '600000', '700000', '800000', '900000', '10000', '20000', '30000', '40000', '50000', '60000', '70000', '80000', '90000']

    const getAgentId = (name) => {
      const parts = name.split('/')
      return parts.length > 2 ? parts[2].split('@')[0] : null
    }

    const isValidDest = (dest) => {
      const isAllowedSeries = departmentSeries.includes(dest)
      const isPhoneNumber = /^\d{12}$/.test(dest)
      return isAllowedSeries || isPhoneNumber
    }

    const parseCallRecord = (record) => {
      let agentId = getAgentId(record.name)
      let dest = record.dest
      const direction = record.direction

      // Ignore invalid records
      if (!agentId || !isValidDest(dest)) {
        return null
      }

      let inorOutbound = ''

      if (direction === 'inbound' && departmentSeries.includes(dest)) {
        if (dest !== agentId) {
          inorOutbound = 'INBOUND'
          dest = record.cid_num
          agentId = record.dest
        }
      } else if (direction === 'inbound' && !departmentSeries.includes(dest)) {
        if (dest !== agentId) {
          inorOutbound = 'OUTBOUND'
        }
      }

      // Set call state
      const callState = record.callstate
      if (callState === 'ACTIVE' && inorOutbound === 'INBOUND') {
        agentId = record.callee_num
      }

      // Duration calculation
      const createdTime = new Date(record.created)
      const durationInSeconds = Math.floor((currentTime - createdTime) / 1000)

      // Ensure duration is not negative
      if (durationInSeconds < 0) {
        return null
      }

      const hours = Math.floor(durationInSeconds / 3600)
      const minutes = Math.floor((durationInSeconds % 3600) / 60)
      const seconds = durationInSeconds % 60

      const durationFormatted = `${hours} h, ${minutes} m, ${seconds} s`

      return {
        callUuid: record.uuid,
        agentId: agentId,
        inorOutbound: inorOutbound,
        callState: callState,
        dest: dest.slice(-10),
        duration: durationFormatted,
      }
    }

    // Check if the response is valid
    if (!response || !Array.isArray(response)) {
      return {
        calls: [],
      }
    }

    const callRecords = response;
    const parsedCalls = callRecords.map(parseCallRecord).filter(Boolean)

    return {
      calls: parsedCalls,
    }
  }
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fsLiveCallsResult = await httpRequest({
          endPoint: `${apiUrl.fsLiveCalls}`,
          method: 'get',
          instance: 'instanceOne'
        })
        if (fsLiveCallsResult.success) {
          const result = processCallRecords(fsLiveCallsResult.data)
          setLiveCalls(result.calls)
        }
      } catch (error) {
        console.error("Error fetching data FS Live Calls API:", error)
      }
    }

    fetchData()

    const intervalId = setInterval(fetchData, 30000)

    return () => clearInterval(intervalId)
  }, [])

  return (
    <Grid className={classes.hrzntlTabLyt}>
      <TableContainer>
        <Table sx={{ minWidth: 36 }} aria-label="simple table">
          <TableHead>
            <TableRow style={{ borderBottom: '2px solid Black' }}>
              <TableCell
                className={classes.tbleHeadTxt}
                align="left"><strong>Agent ID</strong></TableCell>
              <TableCell align="left" className={classes.tbleHeadTxt}><strong>Call UUID</strong></TableCell>
              <TableCell align="left" className={classes.tbleHeadTxt}><strong>InBound / OutBound</strong></TableCell>
              <TableCell align="left" className={classes.tbleHeadTxt}><strong>Call State</strong></TableCell>
              <TableCell align="left" className={classes.tbleHeadTxt}><strong>Destination</strong></TableCell>
              <TableCell align="left" className={classes.tbleHeadTxt}><strong>Duration</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody >
            {liveCalls.map((row) => (
              <TableRow key={row.agentId} style={{ borderBottom: '2px solid Black' }}>
                <TableCell align="left" className={classes.rowText}>{row.agentId}</TableCell>
                <TableCell align="left" className={classes.rowText}>{row.callUuid}</TableCell>
                <TableCell align="left" className={classes.rowText}>{row.inorOutbound}</TableCell>
                <TableCell align="left" className={classes.rowText}>{row.callState}</TableCell>
                <TableCell align="left" className={classes.rowText}>{row.dest}</TableCell>
                <TableCell align="left" className={classes.rowText}>{row.duration}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  )
}

export default withStyles(styles)(AgentsTable)